import 'babel-polyfill'

import Vue from 'vue'

if(document.getElementById("popup_SUPPLIER_RATING_app")) {
    var app = new Vue({
        delimiters: ['[[', ']]'],
        el: '#popup_SUPPLIER_RATING_app',
        data: {
            showRawData: false,
        },
        methods: {
            toggleRawData: function() {
                this.showRawData = !this.showRawData;
            }
        }
    })
}